import { render, staticRenderFns } from "./getPrint.vue?vue&type=template&id=e22e1f8a&scoped=true&"
import script from "./getPrint.vue?vue&type=script&lang=js&"
export * from "./getPrint.vue?vue&type=script&lang=js&"
import style0 from "./getPrint.vue?vue&type=style&index=0&id=e22e1f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22e1f8a",
  null
  
)

export default component.exports